export default __webpack_public_path__ + "static/media/ponentes___MarianaGuerrero.c9e1bec9.jpg";